<template>
    <div>
        <div
            class="lyList"
            v-if="
                this.$route.path != '/index' &&
                this.$route.path != '/login' &&
                this.$route.path != '/'
            "
        >
            <div
                class="lymsg"
                ref="msg"
                v-for="(item, index) in infoList"
                :key="index"
                :style="
                    'left: 40px;' +
                    'bottom: ' +
                    66 * index +
                    'px;' +
                    'z-index:' +
                    -index
                "
                :class="item.zIndex ? 'z9' : ''"
                @click="showCurMsg(index)"
            >
                <div class="top">
                    <img src="../assets/imgs/warning_1.png" />
                    <p>
                        <span>紧急预警</span>
                        <span>{{ item.alarmType }}</span>
                    </p>
                    <div class="closeLyMsg" @click="closeLyMsg(index)">×</div>
                </div>
                <el-form
                    ref="form"
                    :model="item"
                    label-width="120px"
                    class="forms"
                >
                    <el-form-item label="用户姓名:" class="ys">
                        <el-input
                            v-model="item.userName"
                            placeholder=""
                            disabled
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input
                            v-model="item.userMobile"
                            placeholder=""
                            disabled
                            style="width: 88%"
                        ></el-input>
                        <i
                            class="el-icon-phone"
                            :class="call1 ? 'el-icon-phone-red' : ''"
                            title="电话"
                            @click="callPhone(item.userMobile, 1)"
                        ></i>
                    </el-form-item>
                    <el-form-item label="床位地址:">
                        <el-input
                            v-model="item.eventDesc"
                            placeholder=""
                            disabled
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="触发时间:">
                        <el-input
                            v-model="item.eventTime"
                            placeholder=""
                            disabled
                        ></el-input>
                    </el-form-item>

                    <el-collapse v-model="activeName" accordion>
                        <el-collapse-item name="1">
                            <template slot="title">
                                <el-form-item label="物业联系人:">
                                    <el-input
                                        v-model="item.propertyContact"
                                        placeholder=""
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item label="联系人电话:">
                                <el-input
                                    v-model="item.propertyPhone"
                                    placeholder=""
                                    disabled
                                    style="width: 88%"
                                ></el-input>
                                <i
                                    class="el-icon-phone"
                                    :class="call2 ? 'el-icon-phone-red' : ''"
                                    title="电话"
                                    @click="callPhone(item.propertyPhone, 2)"
                                ></i>
                            </el-form-item>
                        </el-collapse-item>
                        <el-collapse-item name="2">
                            <template slot="title">
                                <el-form-item label="监护人:">
                                    <el-input
                                        v-model="item.guardian"
                                        placeholder=""
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item label="监护人电话:">
                                <el-input
                                    v-model="item.guardianPhone"
                                    placeholder=""
                                    disabled
                                    style="width: 88%"
                                ></el-input>
                                <i
                                    class="el-icon-phone"
                                    :class="call3 ? 'el-icon-phone-red' : ''"
                                    title="电话"
                                    @click="callPhone(item.guardianPhone, 3)"
                                ></i>
                            </el-form-item>
                        </el-collapse-item>
                        <el-collapse-item name="3">
                            <template slot="title">
                                <el-form-item label="邻居:">
                                    <el-input
                                        v-model="item.neighbor"
                                        placeholder=""
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item label="邻居电话:">
                                <el-input
                                    v-model="item.neighborPhone"
                                    placeholder=""
                                    disabled
                                    style="width: 88%"
                                ></el-input>
                                <i
                                    class="el-icon-phone"
                                    :class="call4 ? 'el-icon-phone-red' : ''"
                                    title="电话"
                                    @click="callPhone(item.neighborPhone, 4)"
                                ></i>
                            </el-form-item>
                        </el-collapse-item>
                        <el-collapse-item name="4">
                            <template slot="title">
                                <el-form-item label="禾康助老员:">
                                    <el-input
                                        v-model="item.elderHelper"
                                        placeholder=""
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item label="助老员电话:">
                                <el-input
                                    v-model="item.elderHelperPhone"
                                    placeholder=""
                                    disabled
                                    style="width: 88%"
                                ></el-input>
                                <i
                                    class="el-icon-phone"
                                    :class="call5 ? 'el-icon-phone-red' : ''"
                                    title="电话"
                                    @click="callPhone(item.elderHelperPhone, 5)"
                                ></i>
                            </el-form-item>
                        </el-collapse-item>
                        <el-collapse-item name="5">
                            <template slot="title">
                                <el-form-item label="社区监督员:">
                                    <el-input
                                        v-model="item.supervisor"
                                        placeholder=""
                                        disabled
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <el-form-item label="监督员电话:">
                                <el-input
                                    v-model="item.supervisorPhone"
                                    placeholder=""
                                    disabled
                                    style="width: 88%"
                                ></el-input>
                                <i
                                    class="el-icon-phone"
                                    :class="call6 ? 'el-icon-phone-red' : ''"
                                    title="电话"
                                    @click="callPhone(item.supervisorPhone, 6)"
                                ></i>
                            </el-form-item>
                        </el-collapse-item>
                    </el-collapse>

                    <div class="dialog-footer">
                        <el-button type="primary" @click="check(item, index)"
                            >处 置</el-button
                        >
                        <el-button
                            type="primary"
                            @click="closeLyMsg(index)"
                            :disabled="sendMsgBtn"
                            >取消</el-button
                        >
                    </div>

                    <!-- autoplay -->
                </el-form>
            </div>
            <audio
                id="audio"
                src="../assets/imgs/audio.ogg"
                ref="audio"
                loop
                controls
                muted
                autoplay
                style="height: 0px"
                v-if="Isaudio"
            ></audio>
            <el-dialog :visible.sync="showMsg" width="30%" :show-close="false">
                <span class="showText">{{ showMsgText }}成功</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="showMsg = false"
                        >确定</el-button
                    >
                    <el-button @click="showMsg = false">关闭</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import axios from "axios"
// import exportVue from "@/utils/exportVue";
export default {
    name: "lyList",
    data() {
        return {
            infoList: [],
            showMsg: false,
            showMsgText: "",
            Isaudio: false,
            call1: false,
            call2: false,
            call3: false,
            call4: false,
            call5: false,
            call6: false,
            activeName: 1,

            bedinfo: {},
            typeList: [
                { id: "0", name: "主机按键" },
                { id: "1", name: "主机语音" },
                { id: "110", name: "门铃低电量" },
                { id: "1120", name: "门铃恢复电量" },
                { id: "112", name: "门铃按下" },
                { id: "120", name: "呼叫铃低电量" },
                { id: "1220", name: "呼叫铃恢复电量" },
                { id: "122", name: "呼叫铃按下" },
                { id: "130", name: "外出模式开关低电量" },
                { id: "1320", name: "外出模式开关恢复电量" },
                { id: "132", name: "外出模式开关按下" },
                { id: "140", name: "服务铃低电量" },
                { id: "1420", name: "服务铃恢复电量" },
                { id: "142", name: "服务铃按下" },
                { id: "150", name: "门磁低电量" },
                { id: "1520", name: "门磁恢复电量" },
                { id: "152", name: "门磁未闭合" },
                { id: "153", name: "门磁未闭合" },
                { id: "156", name: "门磁闭合" },
                { id: "157", name: "门磁闭合" },
                { id: "1521", name: "门磁配件心跳异常" },
                { id: "1514", name: "门磁打开" },
                { id: "166", name: "气感正常心跳" },
                { id: "1614", name: "气感触发" },
                { id: "1621", name: " 气感配件心跳异常" },
                { id: "170", name: "SOS 低电量" },
                { id: "1720", name: "SOS 恢复电量" },
                { id: "176", name: "SOS 正常心跳" },
                { id: "1721", name: " SOS 配件心跳异常" },
                { id: "178", name: " SOS 触发" },
                { id: "180", name: "烟感低电量" },
                { id: "1820", name: "烟感恢复电量" },
                { id: "186", name: "烟感正常心跳" },
                { id: "1821", name: "烟感配件心跳异常" },
                { id: "188", name: " 烟感触发" },
                { id: "1910", name: " 红外触发" },
                { id: "1915", name: " 红外低电量" },
                { id: "1920", name: "红外恢复电量" },
                { id: "200", name: "标准版遥控器低电量" },
                { id: "2020", name: "标准版遥控器恢复电量" },
                { id: "2012", name: "标准版遥控器触发" },
                { id: "210", name: "孝心眼遥控器低电量" },
                { id: "2120", name: "孝心眼遥控器恢复电量" },
                { id: "2112", name: "孝心眼遥控器触发" },
                { id: "220", name: "水浸报警器低电量" },
                { id: "2220", name: "水浸报警器恢复电量" },
                { id: "226", name: "水浸报警器正常心跳" },
                { id: "2221", name: "水浸报警器配件心跳异常" },
                { id: "2212", name: "水浸报警器触发" },
                { id: "231", name: "睡眠监测带心率异常" },
                { id: "233", name: "睡眠监测带呼吸异常" },
                { id: "234", name: " 睡眠监测带入床" },
                { id: "235", name: " 睡眠监测带配对" },
                { id: "236", name: "睡眠监测带正常心跳" },
                { id: "2321", name: "睡眠监测带配件心跳异常" },
                { id: "2316", name: "睡眠监测带在床异常" },
                { id: "2317", name: "睡眠监测带心率，呼吸率" },
                { id: "2318", name: "睡眠监测带体动，时间和" },
                { id: "2310", name: "睡眠监测带离床" },
                { id: "2313", name: " 睡眠监测带打鼾" },
                { id: "2314", name: "睡眠监测带翻身" },
                { id: "248", name: "一氧化碳报警器触发" },
                { id: "4396", name: "跌倒报警器触发" }
            ],
            socket: null,
            lockReconnect: false,
            sendMsgBtn: false,            timeout: 30 * 1000, //30s一次心跳
            timeoutObj: null, //心跳倒计时
            serverTimeoutObj: null, //心跳心跳倒计时
            timeoutnum: null, //断开
        }
    },
    props: ["dialogsVisible"],
    created() {
        // console.log(this.$store.state.orgId)
        this.getwebsocket()
    },
    watch: {
        infoList(val) {
            // console.log(val);
            if (val.length > 0) {
                setTimeout(() => {
                    this.closeLyMsg(val.length - 1)
                }, this.timeout)
                this.Isaudio = true
            } else {
                this.Isaudio = false
            }
        },
    },
    methods: {
        getwebsocket() {
            var wsUrl =
                "wss://" +
                baseURL
                    .replace("https://", "")
                    .replace("/api", "") +
                ":9097/websocketEventNotice"
            this.socket = new WebSocket(wsUrl)
            this.socket.onerror = (event) => {
                console.log("websocket服务出错了")
                this.reconnect(wsUrl)
            }
            this.socket.onclose = (event) => {
                console.log("websocket服务关闭了")
                this.reconnect(wsUrl)
            }
            this.socket.onopen = (event) => {
                if (
                    this.$route.path != "/index" &&
                    this.$route.path != "/login" &&
                    this.$route.path != "/"
                ) {
                    // console.log(this.$route.path,"连接成功1",sessionStorage.getItem("tokens"),"asss")
                    this.start() //开启心跳
                } else {
                }
            }
            this.socket.onmessage = (event) => {
                //如果获取到消息，心跳检测重置
                //拿到任何消息都说明当前连接是正常的
                // console.log("websocket服务获得数据了", event)
                //接受消息后的UI变化
                // console.log("接收消息");
                // if (JSON.parse(event.data).isAlarm == "true") {
                if (!this.$store.state.info.eventNoticeFlag) {
                    return false
                }
                let info = JSON.parse(event.data)
                // console.log(info)
                info.dataIds.forEach((item) => {
                    if (item == this.$store.state.orgId) {
                        info.showHide = true
                        info.zIndex = false
                        this.$emit("lyclose", true)
                        this.infoList.push(info)
                    }
                })
                let date = new Date(info.eventTime.time)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                let ss = date.getSeconds()
                if (month < 10) {
                    month = "0" + month
                }
                if (day < 10) {
                    day = "0" + day
                }
                if (hh < 10) {
                    hh = "0" + hh
                }
                if (mm < 10) {
                    mm = "0" + mm
                }
                if (ss < 10) {
                    ss = "0" + ss
                }
                this.typeList.forEach((item) => {
                    if (item.id == info.extraCode) {
                        info.alarmType = item.name
                    }
                })
                info.eventTime =
                    year +
                    "-" +
                    month +
                    "-" +
                    day +
                    " " +
                    hh +
                    ":" +
                    mm +
                    ":" +
                    ss

                this.reset()
            }
        },
        reconnect(url) {
            var that = this
            if (that.lockReconnect) {
                return
            }
            that.lockReconnect = true
            //没连接上会一直重连 设置延迟避免请求过多
            that.timeoutnum && clearTimeout(that.timeoutnum)
            that.timeoutnum = setTimeout(function () {
                that.getwebsocket() //新连接
                that.lockReconnect = false
            }, 5000)
        },
        reset() {
            //重置心跳
            var that = this
            clearTimeout(that.timeoutObj)
            clearTimeout(that.serverTimeoutObj)
            that.start() //重启心跳
        },
        //心跳检测
        start() {
            var self = this
            self.timeoutObj && clearTimeout(self.timeoutObj)
            self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj)
            self.timeoutObj = setTimeout(function () {
                // console.log(self.socket, "开始测试心挑")
                //这里发送一个心跳，后端收到后，返回一个心跳消息，
                //onmessage拿到返回的心跳就说明连接正常
                // self.socket.WebSocket.send("心跳测试")
                //如果超过一定时间还没重置，说明后端主动断开了
                self.serverTimeoutObj = setTimeout(function () {
                    //如果onclose会执行reconnect，我们执行ws.close()就行了.
                    //如果直接执行reconnect 会触发onclose导致重连两次
                    self.socket.close()
                }, self.timeout)
            }, self.timeout)
        },
        callPhone(phone, type) {
            // console.log(phone, type)
            if (type == 1) {
                this.call1 = true
            }
            if (type == 2) {
                this.call2 = true
            }
            if (type == 3) {
                this.call3 = true
            }
            if (type == 4) {
                this.call4 = true
            }
            if (type == 5) {
                this.call5 = true
            }
            if (type == 6) {
                this.call6 = true
            }
            if (phone) {
                this.$router.push({
                    name: "customerInfo",
                    params: { phone: phone },
                })
            }
        },
        showCurMsg(iIndex) {
            // console.log(index);
            this.infoList.forEach((item, index) => {
                if (index == iIndex) {
                    item.zIndex = true
                } else {
                    item.zIndex = false
                }
            })
            // console.log(this.infoList[index].zIndex);
        },
        closeLyMsg(index) {
            // console.log(index, this.infoList)
            this.infoList.splice(index, 1)

            if (this.infoList.length == 0) {
                this.Isaudio = false
            }
            // console.log(this.infoList)
        },
        check(item) {
            this.$http
                .request({
                    url: "/ypt/admin/eventNotice/info/saveHandTime",
                    method: "post",
                    data: {
                        remark: item.remark,
                        isHandle: 1,
                        id: item.id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.showMsgText = "处置"
                        this.showMsg = true
                        clearTimeout(this.time)
                        this.Isaudio = false
                        this.infoList.forEach((item, index) => {
                            if (item.msgKey == this.info.msgKey) {
                                this.infoList.splice(index, 1)
                            }
                        })
                        if (this.infoList.length > 0) {
                            this.Isaudio = true
                            this.info = this.infoList[this.infoList.length - 1]
                            this.info.type = String(this.info.type)
                        }
                    }
                })
                .catch((error) => {
                    this.Isaudio = false
                    clearTimeout(this.time)
                })
            // axios({
            //     method: "post",
            //     url: baseURL + "/ypt/admin/eventNotice/info/saveHandTime",
            //     data: {
            //         remark: item.remark,
            //         isHandle: 1,
            //         id: item.id,
            //     },
            // }).then((res) => {
            //     if (res.data.code == 200) {
            //         this.showMsgText = "处置"
            //         this.showMsg = true
            //         clearTimeout(this.time)
            //         this.Isaudio = false
            //         this.infoList.forEach((item, index) => {
            //             if (item.msgKey == this.info.msgKey) {
            //                 this.infoList.splice(index, 1)
            //             }
            //         })
            //         if (this.infoList.length > 0) {
            //             this.Isaudio = true
            //             this.info = this.infoList[this.infoList.length - 1]
            //             this.info.type = String(this.info.type)
            //         }
            //     }
            // }).catch((error) => {
            //     this.Isaudio = false
            //     clearTimeout(this.time)
            // })
        },
        sendMsg() {
            this.showMsgText = "群发"
            this.sendMsgBtn = true
            this.showMsg = true
        },
        goEmergency() {
            // this.$router.push({
            //     name: "emergency",
            // });
            this.showMsg = false
            this.showWarning = false
        },
        common() {
            // console.log(this.infoList)
            this.$emit("lyclose", false)
            this.Isaudio = false
            this.infoList.forEach((item, index) => {
                if (item.msgKey == this.info.msgKey) {
                    this.infoList.splice(index, 1)
                }
            })
            if (this.infoList.length > 0) {
                this.$emit("lyclose", true)
                this.Isaudio = true
                this.info = this.infoList[this.infoList.length - 1]
                this.info.type = String(this.info.type)
            } else {
                this.$emit("lyclose", false)
                this.Isaudio = false
                clearTimeout(this.time)
            }
            //  `console.log(this.infoList.length, "this.infoList.length")
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.el-input {
    width: 100%;
}
.lyList {
    position: relative;
    z-index: 9999;
}
.lymsg {
    position: fixed;
    z-index: 9999;
    width: 462px;
    background: #fff;
    padding-bottom: 25px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    .top {
        background: #f8625d;
        height: 90px;
        width: 92%;
        padding: 0 4%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
            text-align: center;
            span {
                display: block;
                height: 35px;
                line-height: 35px;
                color: #fff;
                &:nth-child(1) {
                    font-size: 20px;
                    font-weight: 500;
                }
                &:nth-child(2) {
                    font-size: 14px;
                }
            }
        }
        img {
            width: 65px;
            height: 65px;
            margin-left: 15px;
        }
        .closeLyMsg {
            width: 22px;
            height: 22px;
            font-size: 22px;
            line-height: 20px;
            border-radius: 100%;
            text-align: center;
            background: #fff;
            color: #f8625d;
            cursor: pointer;
        }
    }

    .forms {
        padding-top: 20px;
    }
}
.z9 {
    z-index: 99 !important;
}
.showText {
    display: block;
    font-size: 14px;
    text-align: center;
}
/deep/.el-input__inner {
    background-color: #f5f5f5;
}
.dialog-footer {
    display: flex;
    justify-content: center;
    text-align: center;
    padding-top: 25px;
}
/deep/.el-button--primary {
    background-color: #f8625d;
    border-color: #f8625d;
    border: none;
    &:hover,
    &:focus,
    &.active {
        background-color: #f8625d;
    }
    &:nth-child(2) {
        margin-left: 55px !important;
    }
}
/deep/ .el-button--primary.is-disabled {
    background: #ffd6d6;
    border-color: #f8625d;
    color: #fff;
    border: none;
    &:hover,
    &:focus,
    &.active {
        background: #ffd6d6;
        color: #fff;
    }
}
/deep/ .el-button--default {
    background: #ffd6d6;
    border-color: #f8625d;
    color: #fff;
    border: none;
    margin-left: 55px !important;
    &:hover,
    &:focus,
    &.active {
        background: #ffd6d6;
        color: #fff;
    }
}
/deep/.el-input.is-disabled .el-input__inner {
    color: #000000;
    font-size: 12px;
}
/deep/.el-form-item__label {
    color: #000000;
    font-size: 14px;
    text-align: left;
    padding-left: 22px;
    position: absolute;
    &:before {
        position: absolute;
        top: 10px;
        left: 5px;
        width: 4px;
        height: 19px;
        display: none;
        background: #f8625d;
        content: "";
    }
}
/deep/.el-form-item {
    margin-bottom: 10px;
    padding-right: 37px;
}
.ys {
    /deep/ .el-form-item__label {
        &:before {
            display: block;
        }
    }
}
/deep/ .el-form-item__content {
    display: flex;
    align-items: center;
}
.el-collapse-item__header .el-form-item {
    width: 100%;
    /deep/ .el-form-item__content {
        width: 76%;
    }
    /deep/ .el-form-item__label {
        &:before {
            display: block;
        }
    }
}
/deep/ .el-icon-phone {
    width: 22px;
    height: 23px;
    margin-left: 5px;
    background: url("../assets/imgs/tel_g.png") no-repeat center / 22px 23px;
    cursor: pointer;
    &:before {
        content: "";
    }
}
.el-icon-phone-red {
    background: url("../assets/imgs/tel_r.png") no-repeat center / 22px 23px;
}
/deep/ .el-collapse-item__header {
    border: none;
}
/deep/ .el-collapse-item__wrap {
    border: none;
}
/deep/ .el-collapse-item__content {
    padding: 0;
}
/deep/ .el-collapse {
    border: none;
}
/deep/ .el-collapse-item__arrow {
    margin-bottom: 10px;
}
</style>
